/** Sincroniza estado de la app con query params en la URL.
 *
 * Params soportados (rango principal — período A):
 *   region=13                CUT de la región seleccionada
 *   dateStart=2026-05-15     YYYY-MM-DD (inclusivo)
 *   dateEnd=2026-05-15       YYYY-MM-DD (inclusivo). Single-day si == dateStart.
 *   timeStart=08:00          HH:MM (filtro fino). Omitido = día completo.
 *   timeEnd=22:30            HH:MM (filtro fino).
 *   jams=0                   si está, oculta jams
 *   alerts=0                 si está, oculta alerts
 *   lat=-33.45               viewport center latitude
 *   lng=-70.65               viewport center longitude
 *   zoom=12                  viewport zoom (1 decimal)
 *
 * Período B (comparativa) — mismos campos prefijo `c`:
 *   cDateStart, cDateEnd, cTimeStart, cTimeEnd, compareMode
 *
 * Backward compat: date/hour/minute viejos siguen leídos si dateStart no está.
 *
 * Por defecto los params se omiten cuando matchean el default
 * para mantener URLs cortas y legibles.
 */

export function readURL() {
  if (typeof window === "undefined") return {};
  const p = new URLSearchParams(window.location.search);
  const obj = {};
  [
    "region",
    "dateStart", "dateEnd", "timeStart", "timeEnd",
    "cDateStart", "cDateEnd", "cTimeStart", "cTimeEnd", "compareMode",
    "date", "hour", "minute",  // legacy
    "commune", "jams", "alerts", "lat", "lng", "zoom",
  ].forEach((k) => {
    const v = p.get(k);
    if (v != null) obj[k] = v;
  });
  return obj;
}

/** Merge partial state into the URL query string sin agregar entradas al
 * history. Si un valor es null/undefined, elimina la key. */
export function writeURL(patch) {
  if (typeof window === "undefined") return;
  const p = new URLSearchParams(window.location.search);
  for (const [k, v] of Object.entries(patch)) {
    if (v === null || v === undefined || v === "") p.delete(k);
    else p.set(k, String(v));
  }
  const qs = p.toString();
  const url = qs ? `${window.location.pathname}?${qs}` : window.location.pathname;
  window.history.replaceState(null, "", url);
}

export function parseInitialViewport(url) {
  const lat = parseFloat(url.lat);
  const lng = parseFloat(url.lng);
  const zoom = parseFloat(url.zoom);
  if (Number.isFinite(lat) && Number.isFinite(lng) && Number.isFinite(zoom)) {
    return { latitude: lat, longitude: lng, zoom };
  }
  return null;
}
